﻿import { Car } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import type { Vehicle } from "@/hooks/customers/useCustomerData";;

export function VehicleModal({
  addingVehicleTo,
  setAddingVehicleTo,
  editingVehicle,
  setEditingVehicle,
  saveVehicle,
}: {
  addingVehicleTo: string | null;
  setAddingVehicleTo: (id: string | null) => void;
  editingVehicle: Vehicle | null;
  setEditingVehicle: (v: Vehicle | null) => void;
  saveVehicle: any;
}) {
  return (
    <Dialog
      open={!!addingVehicleTo || !!editingVehicle}
      onOpenChange={(open) => {
        if (!open) {
          setAddingVehicleTo(null);
          setEditingVehicle(null);
        }
      }}
    >
      <DialogContent className="sm:max-w-[425px] bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2">
            <Car size={20} />{" "}
            {editingVehicle ? "Editar Veículo" : "Adicionar Veículo"}
          </DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const fd = new FormData(e.currentTarget);
            saveVehicle.mutate(
              {
                id: editingVehicle?.id,
                customer_id: editingVehicle?.customer_id || addingVehicleTo!,
                plate: fd.get("plate") as string,
                model: fd.get("model") as string,
                color: fd.get("color") as string,
              },
              {
                onSuccess: () => {
                  setAddingVehicleTo(null);
                  setEditingVehicle(null);
                },
              },
            );
          }}
          className="space-y-4 mt-2"
        >
          <div className="space-y-2">
            <label className="text-sm text-slate-300">Placa *</label>
            <Input
              name="plate"
              defaultValue={editingVehicle?.plate}
              required
              className="bg-slate-800 border-slate-700 text-white uppercase font-bold tracking-widest"
              placeholder="ABC-1234"
              maxLength={8}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="text-sm text-slate-300">Modelo *</label>
              <Input
                name="model"
                defaultValue={editingVehicle?.model}
                required
                className="bg-slate-800 border-slate-700 text-white"
                placeholder="Ex: Onix"
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm text-slate-300">Cor</label>
              <Input
                name="color"
                defaultValue={editingVehicle?.color}
                className="bg-slate-800 border-slate-700 text-white"
                placeholder="Ex: Prata"
              />
            </div>
          </div>
          <div className="pt-4 flex justify-end gap-2 border-t border-slate-800">
            <Button
              type="button"
              variant="ghost"
              onClick={() => {
                setAddingVehicleTo(null);
                setEditingVehicle(null);
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={saveVehicle.isPending}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {saveVehicle.isPending ? "Salvando..." : "Salvar Veículo"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
